import React, { useContext, useRef, memo } from 'react'
import {
  Toolbar,
  Typography,
  Grid,
  TextField,
  IconButton,
  makeStyles,
  lighten,
  Tooltip,
} from '@material-ui/core'
import clsx from 'clsx'
import { isArray } from 'lodash'
import { TableContext } from '../Table/Table'

const useStyles = makeStyles((theme) => ({
  toolbar: {
    minHeight: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
    lineHeight: '50px',
  },
}))

const TableToolbar = memo(function TableToolbar({
  numSelected,
  actions,
  title,
  disableFilter,
  filterLabel,
  lista,
  indexToSelect,
  fixedToolbar,
}) {
  const classes = useStyles()
  const { selected, dispatch } = useContext(TableContext)

  const filterTime = useRef()

  const handleChange = (e) => {
    const value = e.target.value
    clearTimeout(filterTime.current)
    filterTime.current = setTimeout(() => {
      dispatch({ type: 'setFilter', value })
    }, 300)
  }

  return (
    <Toolbar
      className={clsx(classes.toolbar, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} {numSelected === 1 ? 'selecionado' : 'selecionados'}
        </Typography>
      ) : (
        <Grid container spacing={2} style={{ marginRight: 0 }}>
          {title && (
            <Grid item xs style={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                className={classes.title}
                variant="h6"
                component="div"
              >
                {title}
              </Typography>
            </Grid>
          )}
          {!disableFilter && (
            <Grid item xs>
              <TextField
                label={filterLabel}
                fullWidth
                margin="dense"
                variant="outlined"
                onChange={handleChange}
              />
            </Grid>
          )}
        </Grid>
      )}
      {(fixedToolbar || numSelected > 0) &&
        isArray(actions) &&
        actions.map((action, i) => (
          <Tooltip title={action[0]} key={i}>
            <IconButton
              onClick={(e) =>
                action[2](
                  selected,
                  e,
                  lista.filter(
                    (linha) => selected.indexOf(linha[indexToSelect]) > -1,
                  ),
                )
              }
            >
              {action[1]}
            </IconButton>
          </Tooltip>
        ))}
    </Toolbar>
  )
})

export default TableToolbar
